import React from 'react';
import { Route } from 'react-router-dom';
import RequireAuth from './RequireAuth';
import { NoticeList } from '../components/Support';

// 고객지원 관리
const SupportRoute = ({sessionUser}) => {

    return (
        <>
            {/* 공지사항 */}
            <Route path="/notice" element={
                <RequireAuth sessionUser={sessionUser}>
                    <NoticeList/>
                </RequireAuth>
            } />
           
        </> 
    );
};

export default SupportRoute;